import { useLocation, useNavigate } from "react-router-dom";

export const useApp = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return { navigate, location };
};
